var eoshDomain = Shopify.shop;
        var removePagination = document.querySelectorAll(".Pagination Text--subdued, .pagination, .pagination-border-top, .pagination-custom, .Pagination, .justify-content-center, .collection-pagination, .box__paginate, .paginate, .pagination--container, #pagination, .collection--pagination");
        if(window.location.href.indexOf("collections")>-1 || (window.location.href.indexOf("search")>-1 && (Shopify.shop=="thisisneverthatstore.myshopify.com" || Shopify.shop=="thisisneverthat-intl.myshopify.com") ))
    	{
            if(typeof(removePagination[0])!="undefined"){
                removePagination[0].style.display="none"; 
            }
        }
        window.onload=function(){
            var eoShFileExist=document.querySelector("script[src*='https://loadmore-infinitescroll.extendons.com']"); 
            if(eoShFileExist==null){ 
                if(typeof(removePagination[0])!="undefined"){
                removePagination[0].style.display="none"; 
              } 
            }
        }